module.exports = __webpack_public_path__ + "static/media/animatedPostures.f2dc2c0d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/animatedPostures.gif
// module id = 157
// module chunks = 0